module.exports = __webpack_public_path__ + "static/media/3DPPA37.fac64831.jpg";